/**
 * Product Accordion
 * 
 * This script handles the accordion functionality for product pages.
 * All accordions start closed by default.
 */

(function() {
  function initAccordions() {
    // Find all accordions
    const accordions = document.querySelectorAll('[data-accordion]');
    
    // Exit if none found
    if (!accordions.length) return;
    
    // Get all accordion buttons
    const accordionButtons = document.querySelectorAll('.product__accordion-button');
    
    // Function to toggle the accordion state
    function toggleAccordion() {
      // Toggle active class for the button
      this.classList.toggle('active');
      
      // Get the content element
      const content = this.nextElementSibling;
      content.classList.toggle('active');
      
      // Close other accordions
      accordionButtons.forEach(otherButton => {
        if (otherButton !== this) {
          otherButton.classList.remove('active');
          otherButton.nextElementSibling.classList.remove('active');
        }
      });
    }
    
    // Initialize each accordion
    accordionButtons.forEach(button => {
      // Remove existing event listeners first
      button.removeEventListener('click', toggleAccordion);
      // Add event listener
      button.addEventListener('click', toggleAccordion);
      
      // All accordions closed by default
    });
  }
  
  // Run on page load
  document.addEventListener('DOMContentLoaded', initAccordions);
  
  // Also run when the page content is updated
  document.addEventListener('shopify:section:load', initAccordions);
})();
